
import { VideoPlayer } from "@videojs-player/vue";
import mobile from "is-mobile";
import videojs from "video.js";
import { defineComponent, PropType } from "vue";
import logger from "@/services/logger";

import Player = videojs.Player;

export default defineComponent({
  name: "OculaiVideoPlayer",
  props: {
    src: {
      type: String as PropType<string | null>,
      required: false,
      default: null,
    },
    loading: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
    noSrcMessage: {
      type: String as PropType<string>,
      required: false,
    },
    hls: {
      type: Boolean as PropType<boolean>,
      required: false,
    },
    autoPlay: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: true,
    },
  },
  computed: {
    showPlayer(): boolean {
      return !this.loading && !!this.src && !this.hasError;
    },
  },
  components: {
    VideoPlayer,
  },
  data() {
    return {
      hasError: false,
    };
  },
  methods: {
    handleError(event: Event) {
      this.hasError = true;
      const target = event.target as unknown as { player: Player };
      const error = target.player.error() as MediaError & { src?: string | null };
      error.src = this.src;
      logger.error("Unhandled error in video player", error);
    },
    handleMounted(event: { player: Player }) {
      if (mobile() || !this.autoPlay) {
        return;
      }
      // based on https://videojs.com/blog/autoplay-best-practices-with-video-js/
      const playPromise = event.player.play();
      if (playPromise) {
        playPromise.catch((error) => {
          const knownErrors = [
            "The play() request was interrupted",
            "The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.",
            "The fetching process for the media resource was aborted by the user agent at the user's request.",
            "The operation was aborted.",
            "Failed to load because no supported source was found.",
          ];
          if (knownErrors.every((errorMessage) => !error.message.includes(errorMessage))) {
            error.src = this.src;
            logger.error("Unable to auto play video", error);
          }
        });
      }
    },
  },
  watch: {
    src() {
      this.hasError = false;
    },
    loading() {
      this.hasError = false;
    },
  },
});
